<template>
  <app-cell
    class="express-shipping-cell"
    :edit="!!form"
    :deletable="false"
    :loading="!!form && form.isLoading"
    @edit="onEdit"
    @save="onSave"
    @cancel="onCancel"
  >
    <template slot="content" v-if="expressShipping">
      <div class="express-shipping-cell__content">
        <h2 class="express-shipping-cell__title">
          {{ expressShipping.title }}
        </h2>
        <p class="express-shipping-cell__price">
          Price:
          <b>{{ expressShipping.price }}</b>
          <strong class="usd">({{ currentUsdPrice }})</strong>
        </p>

        <base-stack direction="row">
          <slider
            class="express-shipping-cell__slider"
            v-if="expressShipping.imageUrls.length"
            :images="expressShipping.imageUrls"
          />
          <base-stack>
            <html-renderer :html="expressShipping.description" />
          </base-stack>
        </base-stack>
      </div>
    </template>
    <template slot="form" v-if="!!form">
      <base-stack as="form" @submit.prevent class="express-shipping-cell__form">
        <base-form-input class="form__input" label="Title">
          <input v-model="form.title" placeholder="Title" />
        </base-form-input>
        <base-form-input class="form__input" label="Price">
          <input v-model.number="form.price" placeholder="Price" type="number" />
          <template slot="hint">{{
            inputUsdPrice ? `= ${inputUsdPrice}` : 'In USD x 1000, i.e. $100.00 = 100000'
          }}</template>
        </base-form-input>
        <base-form-input class="form__input" label="Description">
          <app-html-editor v-model="form.description" />
        </base-form-input>
      </base-stack>
    </template>
  </app-cell>
</template>

<script lang="ts">
import AppCell from '@/components/Cell.vue';
import AppHtmlEditor from '@/components/HtmlEditor.vue';
import HtmlRenderer from '@/components/HtmlRenderer.vue';
import Slider from '@/components/Slider.vue';
import { UpdateExpressShippingForm } from '@/forms/purchasable/UpdateExpressShippingForm';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ExpressShipping } from '../types/api';

@Component({
  components: { AppCell, AppHtmlEditor, HtmlRenderer, Slider },
})
export default class ExpressShippingCell extends Vue {
  @Prop({ required: true })
  expressShipping!: ExpressShipping;

  public form: UpdateExpressShippingForm | null = null;

  public get currentUsdPrice(): string {
    const price = this.expressShipping.price;
    return `$${price / 1000}`;
  }

  public get inputUsdPrice() {
    const price = this.form?.price;
    return price ? `$${price / 1000}` : null;
  }

  public onEdit() {
    this.form = new UpdateExpressShippingForm(this.expressShipping);
  }

  public onCancel() {
    this.closeForm();
  }

  public async onSave() {
    await this.form?.save();
    this.closeForm();
  }

  private closeForm() {
    this.form = null;
    this.$emit('close');
  }
}
</script>

<style lang="scss" scoped>
.express-shipping-cell {
  &__title {
    strong {
      margin-left: 8px;
      font-size: 1rem;
    }
  }
  &__price {
    margin-bottom: 16px;
    b {
      font-weight: bold;
    }
    strong {
      margin-left: 8px;
    }
  }

  &__slider {
    flex-shrink: 0;
    height: 220px;
    width: 240px;
    max-width: 400px;
    margin-right: 16px;
  }

  &__form {
    flex: 1;
    max-width: 600px;
    display: flex;
    flex-direction: column;
  }
}
</style>
